
import { of as observableOf } from 'rxjs';
import { withLatestFrom, switchMap, catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { Http } from '@angular/http';

import {
  REQUEST_ORGANIZATIONS,
  RECEIVE_ORGANIZATIONS,
  REQUEST_CURRENT_ORGANIZATION,
  receiveOrganizations,
  requestOrganizations,
  receiveCurrentOrganization,
} from './organizations.actions';

import { IAppState } from '../app.state';

import { normalize, schema } from 'normalizr';

import { Config } from '../universal-config';

const organization = new schema.Entity('organizations', {}, {idAttribute: 'globalId'});
const currentOrganization = new schema.Entity('currentOrganization');

@Injectable()
export class OrganizationsEffects {
  url = '/orgs';
  currentOrgUrl = '/org';
  shareApiService;

  @Effect() requestOrganizations$ = this.actions$
    .ofType<any>(REQUEST_ORGANIZATIONS).pipe(
    withLatestFrom(this.store$),
    map(([action, state]) => action.payload),
    switchMap((action) => {
      return this.http.get(`${this.shareApiService}${this.url}`).pipe(
        catchError(() => observableOf(false)));
    }),
    map((response: any) => {
      return receiveOrganizations(normalize({organizations: response.json()}, {organizations: [organization]}));
    }),
    catchError((err) => observableOf({ type: 'REQUEST_FAILED' })),);

  @Effect() requestCurrentOrganization$ = this.actions$
    .ofType<any>(REQUEST_CURRENT_ORGANIZATION).pipe(
    withLatestFrom(this.store$),
    map(([action, state]) => action.payload),
    switchMap((action) => {
      return this.http.get(`${this.shareApiService}${this.currentOrgUrl}`).pipe(
        catchError(() => observableOf(null)));
    }),
    map((response: any) => {
      return receiveCurrentOrganization(response.json());
    }),
    catchError((err) => observableOf({ type: 'REQUEST_CURRENT_ORG_FAILED' })),);

  constructor(
    public actions$: Actions,
    public store$: Store<IAppState>,
    public http: Http,
    public _config: Config
  ) {
    this.shareApiService = _config.get('SHARE_API_SERVICE');
  }
}
